import { useEffect } from "react";
import { Link } from "react-router-dom";
import { X, MessageCircle } from "lucide-react";

/* Avatar-Lightbox: click on any avatar to enlarge it */
export default function AvatarLightbox({ src, name, subline, onClose, chatHref }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  const initials = (name || "").split(" ").map((p) => p[0] || "").join("").slice(0, 2).toUpperCase();
  const apiBase = process.env.REACT_APP_BACKEND_URL || "";
  const fullSrc = src ? (src.startsWith("/") ? `${apiBase}${src}` : src) : "";

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/92 backdrop-blur-md flex items-center justify-center p-4 avatar-lb-fade"
      onClick={onClose}
      data-testid="avatar-lightbox"
    >
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white/60 hover:text-white border border-white/15 w-9 h-9 flex items-center justify-center"
        aria-label="Schließen"
        data-testid="avatar-lightbox-close"
      >
        <X size={16} />
      </button>
      <div className="max-w-md w-full flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
        {fullSrc ? (
          <img
            src={fullSrc}
            alt={name || "Avatar"}
            className="max-w-[70vw] max-h-[70vh] object-contain border border-white/10"
            data-testid="avatar-lightbox-img"
          />
        ) : (
          <div className="w-64 h-64 flex items-center justify-center border border-white/15 bg-white/[0.03] text-[64px] font-outfit font-black text-white/80 tracking-wider">
            {initials}
          </div>
        )}
        <div className="mt-4 text-center">
          <div className="text-white font-outfit font-bold text-xl tracking-tight" data-testid="avatar-lightbox-name">{name}</div>
          {subline && <div className="text-white/55 text-sm mt-1">{subline}</div>}
          {chatHref && (
            <Link
              to={chatHref}
              onClick={onClose}
              data-testid="avatar-lightbox-chat"
              className="inline-flex items-center gap-2 mt-4 px-4 h-10 border border-[#00e5ff]/50 text-[#00e5ff] hover:bg-[#00e5ff]/10 hover:border-[#00e5ff] transition-colors font-outfit font-semibold text-[13px] uppercase tracking-wider"
            >
              <MessageCircle size={13} /> Direkt anschreiben
            </Link>
          )}
        </div>
      </div>
      <style>{`
        .avatar-lb-fade { animation: lb-in 0.2s ease-out; }
        @keyframes lb-in { from { opacity: 0; } to { opacity: 1; } }
      `}</style>
    </div>
  );
}
